import * as styles from './index.module.scss';
import { marketingPartners } from '@/data/marketing_partners';

const EXTERNAL_LIST_URL = 'https://hs.leadpost.net/clientList.jsp';

export const MarketingPartnersList = () => {
  const sortedParters = marketingPartners.sort();
  const linkedPartners = ['QuinStreet', 'Modernize'];
  return (
    <div className={'container'}>
      <h2 className={styles['heading']}>Marketing Partners</h2>
      <ul className={styles['marketing-partners-list']}>
        {sortedParters.map((partner, i) => (
          <li key={i}>
            {linkedPartners.includes(partner) ? (
              <a className={styles['link']} href={EXTERNAL_LIST_URL}>
                {partner}
              </a>
            ) : (
              partner
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
